import { render, staticRenderFns } from "./leoCalendarNew.vue?vue&type=template&id=a2336cf6&"
import script from "./leoCalendarNew.vue?vue&type=script&lang=js&"
export * from "./leoCalendarNew.vue?vue&type=script&lang=js&"
import style0 from "./leoCalendarNew.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports